import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { getDatabase, ref, push } from "firebase/database";
import app from "../firebaseConfig"; // Import Firebase config
import FeedbackList from "./Feedbacklist";
const Write = () => {
  const [name, setName] = useState("");
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(false);

  const getFormattedTime = () => new Date().toISOString();

  const saveData = () => {
    if (!name || !feedback || rating === 0) {
      setError(true);
      setTimeout(() => setError(false), 3000);
      return;
    }

    setIsSubmitting(true);
    const db = getDatabase(app);
    const feedbackRef = ref(db, "urocare/feedback");
    const submissionTime = getFormattedTime();

    push(feedbackRef, {
      name,
      feedback,
      rating,
      timestamp: submissionTime,
    })
      .then(() => {
        setMessage(`Thank you for your feedback! Submitted at: ${new Date(submissionTime).toLocaleString()}`);
        setName("");
        setFeedback("");
        setRating(0);
        setTimeout(() => {
          setIsSubmitting(false);
          setMessage("");
        }, 5000);
      })
      .catch((error) => {
        alert("Error submitting feedback: " + error.message);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      {/* No design changes below */}
      <section className="min-h-screen flex items-center justify-center bg-black">
        <div className="absolute top-0 left-0 w-full h-full z-0">
          <img
            src="/images/feedback_background.webp"
            alt="Background showing patient feedback and testimonials"
            className="w-full h-full object-cover opacity-40"
            loading="lazy"
          />
        </div>

        <div className="bg-gray-900 bg-opacity-90 text-white shadow-xl rounded-lg p-8 z-10">
          <h1 className="text-2xl font-bold text-center mb-4">We Value Your Feedback!</h1>

          <form onSubmit={(e) => e.preventDefault()} aria-labelledby="feedback-heading" className="flex flex-col items-center">
            <input
              type="text"
              id="name"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-3 border border-gray-500 rounded-md mb-4 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-teal-500"
              disabled={isSubmitting}
              required
            />

            <textarea
              id="feedback"
              placeholder="Write your feedback here..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              className="w-full p-3 border border-gray-500 rounded-md mb-4 h-28 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-teal-500"
              disabled={isSubmitting}
              required
            ></textarea>

            <fieldset className="mb-6">
              <legend className={`text-gray-300 font-medium text-center ${error ? "text-red-500" : ""}`}>
                Rate Our Service:
              </legend>
              <div className={`flex justify-center mt-2 ${error ? "animate-shake" : ""}`}>
                {[...Array(5)].map((_, index) => {
                  const currentRating = index + 1;
                  return (
                    <label key={index}>
                      <input
                        type="radio"
                        name="rating"
                        className="hidden"
                        value={currentRating}
                        onClick={() => setRating(currentRating)}
                        required
                      />
                      <FaStar
                        size={30}
                        className="cursor-pointer transition-colors duration-200"
                        color={currentRating <= (hover || rating) ? "#FFD700" : "#e4e5e9"}
                        onMouseEnter={() => setHover(currentRating)}
                        onMouseLeave={() => setHover(null)}
                      />
                    </label>
                  );
                })}
              </div>
            </fieldset>

            <button
              type="submit"
              onClick={saveData}
              disabled={isSubmitting}
              className={`w-full py-3 rounded-md text-lg font-semibold transition duration-300 
                ${isSubmitting ? "bg-gray-600 cursor-not-allowed" : "bg-teal-600 hover:bg-teal-700 text-white"}`}
              aria-label="Submit feedback"
            >
              {isSubmitting ? "Submitting..." : "Submit Feedback"}
            </button>

            {message && <p className="text-center text-green-400 mt-4 text-lg">{message}</p>}
          </form>
        </div>
      </section>
      
    </>
  );
};

export default Write;
